import * as api from './api'
import * as reducers from './slice-reducers'
import * as adminReducers from '../admin/slice'
import { AppDispatch } from 'src/app/store'
import { AdminDeposit, Deposit, SmallDeposit } from 'src/core/models'

export const getDepositsList = (total = 0) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setDepositsListLoading(true))
    const data: Deposit[] = await api.getDepositsListAPI(total)
    dispatch(reducers.setDepositsListLoading(false))
    dispatch(reducers.setDepositsListData(data))
    dispatch(reducers.setFilteredDeposits(data))
  } catch (error) {
    dispatch(reducers.setDepositsListLoading(false))
    dispatch(reducers.setDepositsListError(error))
  }
}

export const removeDeposits = (deposits: Deposit[]) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setRemoveDepositsLoading(true))
    await api.removeDepositsAPI(deposits)
    dispatch(reducers.setRemoveDepositsLoading(false))
    dispatch(reducers.setRemoveDepositsSuccess(true))
    dispatch(getDepositsList())
  } catch (error) {
    dispatch(reducers.setRemoveDepositsLoading(false))
    dispatch(reducers.setRemoveDepositsSuccess(false))
    dispatch(reducers.setRemoveDepositsError(error))
  }
}

export const getDepositDetails = (id: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFetchDepositsLoading(true))
    const deposit: SmallDeposit = await api.fetchDepositAPI(id)
    dispatch(reducers.setFetchDepositsData(deposit))
    dispatch(reducers.setFetchDepositsLoading(false))
  } catch (error) {
    dispatch(reducers.setFetchDepositsLoading(false))
    dispatch(reducers.setRemoveDepositsSuccess(false))
    dispatch(reducers.setRemoveDepositsError(error))
  }
}

export const validateDeposit = (id: number,  bigList: AdminDeposit[]) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setValidateDepositCurrentId(id))
    dispatch(reducers.setValidateDepositLoading(true))
    await api.validateDepositAPI(id)
    const newList: AdminDeposit[] = bigList.filter(d => d.id !== id)
    dispatch(adminReducers.setAdminDepositsData(newList))
    dispatch(reducers.setValidateDepositSuccess(true))
    dispatch(reducers.setValidateDepositLoading(false))
  } catch (error) {
    dispatch(reducers.setValidateDepositLoading(false))
    dispatch(reducers.setValidateDepositSuccess(false))
    dispatch(reducers.setValidateDepositCurrentId(null))
  }
}

export const cancelDeposit = (id: number,  bigList: AdminDeposit[]) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCancelDepositCurrentId(id))
    dispatch(reducers.setCancelDepositLoading(true))
    await api.cancelDepositAPI(id)
    const newList: AdminDeposit[] = bigList.filter(d => d.id !== id)
    dispatch(adminReducers.setAdminDepositsData(newList))
    dispatch(reducers.setCancelDepositSuccess(true))
    dispatch(reducers.setCancelDepositLoading(false))
  } catch (error) {
    dispatch(reducers.setCancelDepositLoading(false))
    dispatch(reducers.setCancelDepositSuccess(false))
    dispatch(reducers.setCancelDepositCurrentId(null))
  }
}
